import styled from "styled-components"

interface WrapperProps {
  isScrolling: boolean
}

export const Wrapper = styled.div<WrapperProps>`
  pointer-events: ${(props) => (props.isScrolling ? "none" : "auto")};
`
